// extracted by mini-css-extract-plugin
module.exports = {"body":"_6d2018c","twoColumns":"_d2c4325","main":"_8f99213","side":"_42a06f7","embeddedContainer":"_e41bfcf","mainSkeleton":"_7b5bf84"};